export default (text, length = 15) => {
  if (!text || text.length < length) return text;
  return `${text.slice(0, length - 3)}...`;
};
